export const ru = {
    CLICKS: 'Клики',
    CPC: 'CPC',
    CPM: 'CPM',
    CTR: 'CTR',
    DEAL_TYPE: 'Тип',
    MIN_PRICE: 'Мин. цена тыс. показов',
    NAME: 'Название',
    SHOWS: 'Показы',
    SPENT: 'Расходы',
    STATUS: 'Статус',
    'without-nds': 'Без учета НДС'
};
